// extracted by mini-css-extract-plugin
export default {"wrapper":"tableTab_wrapper__WK2IR","tab_box":"tableTab_tab_box__dcpRY","tab":"tableTab_tab__bP4Xt","active":"tableTab_active__AoLtJ","pannel":"tableTab_pannel__0+FZy"};